import { request } from './client';

export function login({ email, password }) {
  return request('/api/auth/player/login', { method: 'POST', body: { email, password } });
}

export function logout() {
  return request('/api/auth/player/logout', { method: 'POST' });
}

// Session probe: 200 with the player when a session cookie is live, 401 otherwise.
export function getCurrentPlayer() {
  return request('/api/auth/player/current');
}

export function register(player) {
  return request('/api/players', { method: 'POST', body: player });
}
